import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CheckBox, DBTextAreaContrain } from '_components';
import styles from './Contraindications.module.css';

class PatientCareCenterNoteContraindications extends React.Component {


    handleNone() {
        let val;
        this.props.none ? val = '' : val = 'None';

        this.props.noteType === 1 ?
            this.props.updateContrain(this.props.noteId, this.props.epno, 'PTEVAL', 'EVNO', this.props.pk, 'EVCONTRAIN', val) :
            this.props.updateContrain(this.props.noteId, this.props.epno, 'PTNOTE', 'NTNO', this.props.pk, 'NTCONTRAIN', val);
    }

    render() {
        return (
            <div className={styles.wrapper}>
                <div className={styles.top_row}>
                    <label className={styles.contrain_label}>Contraindications</label>
                    <CheckBox
                        size='extra-small'
                        className={styles.checkbox}
                        checked={this.props.none}
                        label='None'
                        onClick={() => this.handleNone()}
                    />

                </div>
                { this.props.noteType === 1 &&
                    <DBTextAreaContrain
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.pk}
                        field='EVCONTRAIN'
                        disabled={this.props.none}
                        className={styles.textarea}
                        epno={this.props.epno}
                    />
                }
                { this.props.noteType !== 1 &&
                    <DBTextAreaContrain
                        noteId={this.props.noteId}
                        entity='PTNOTE'
                        entityKeyColumn='NTNO'
                        entityKeyValue={this.props.pk}
                        field='NTCONTRAIN'
                        disabled={this.props.none}
                        className={styles.textarea}
                        epno={this.props.epno}
                    />
                }
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateContrain: bindActionCreators(noteActions.updateContrain, dispatch)
    };
}


function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let none = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVCONTRAIN === 'None' : state.entities.notes.PTNOTE[pk].NTCONTRAIN === 'None';

    return {
        noteId: noteId,
        noteType: noteType,
        pk: pk,
        epno: epno,
        none: none
    };
}

const connectedPatientCareCenterNoteContraindications = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteContraindications);
export { connectedPatientCareCenterNoteContraindications as PatientCareCenterNoteContraindications };

